module.exports = __webpack_public_path__ + "h5/img/strokes-1.f54ee514.png";